<div class="w-100 d-flex align-items-center banner pl-3">
	<div class="craftnote-label dark bold mr-2">
		{{ 'toc.dialog.label' | translate }}
	</div>
	<div [innerHTML]="'toc.banner.body' | translate: { tocLink: linkService.tocLink, tocDeadline: tocDeadline$ | async }"></div>
	<button mat-stroked-button class="mx-3 flex-shrink-0" (click)="acceptToc()">Accept our T&C</button>
</div>
